import { render, staticRenderFns } from "./bindNewAcct.vue?vue&type=template&id=6e5ee3d2"
import script from "./bindNewAcct.vue?vue&type=script&lang=js"
export * from "./bindNewAcct.vue?vue&type=script&lang=js"
import style0 from "./bindNewAcct.vue?vue&type=style&index=0&id=6e5ee3d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports